<form [formGroup]="inputForm" novalidate>
    <div class="m-content">
        <div class="m-list-search">
            <div class="m-list-search__results">
                <div class="m-list-search__result-item">
                    <span class="m-list-search__result-item-icon">
                        <i ngbTooltip="Naziv" class="la la-i-cursor m--font-inverse-light" i18n-ngbTooltip></i>
                    </span>
                    <span class="m-list-search__result-item-text">
                        <input type="text" placeholder="Naziv" formControlName="name" class="form-control form-control-sm m-input" i18n-placeholder />
                    </span>
                </div>
                <div *ngIf="inputForm.controls['name'].errors && formSubmitted" class="m--font-danger ml-4">
                    <div [hidden]="!inputForm.controls['name'].errors.required" class="ml-3" i18n="@@new.payer.error.title">
                        Naziv je obvezno polje.
                    </div>
                </div>
                <div class="m-list-search__result-item">
                    <span class="m-list-search__result-item-icon">
                        <i class="la la-map-marker m--font-inverse-light"></i>
                    </span>
                    <div class="row">
                        <div class="col-xl-6 col-md-6">
                            <input
                                type="text"
                                placeholder="Ulica"
                                formControlName="addressName"
                                class="form-control form-control-sm m-input"
                                i18n-placeholder
                            />
                            <div *ngIf="inputForm.controls['addressName'].errors && formSubmitted" class="m--font-danger">
                                <div [hidden]="!inputForm.controls['addressName'].errors.required" i18n="@@new.payer.error.addressName">
                                    Ulica je obvezno polje.
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-6">
                            <input
                                type="text"
                                placeholder="Hišna številka"
                                formControlName="addressNumber"
                                class="form-control form-control-sm m-input"
                                i18n-placeholder
                            />

                            <div *ngIf="inputForm.controls['addressNumber'].errors && formSubmitted" class="m--font-danger">
                                <div [hidden]="!inputForm.controls['addressNumber'].errors.required" i18n="@@new.payer.error.addressNumber">
                                    Hišna številka je obvezno polje.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="m-list-search__result-item">
                    <span class="m-list-search__result-item-icon"></span>
                    <span class="m-list-search__result-item-text">
                        <div class="row">
                            <div class="col-xl-6 col-md-6">
                                <ng-select
                                    [items]="zipCodes"
                                    [addTag]="true"
                                    [clearable]="false"
                                    [virtualScroll]="true"
                                    (change)="fillCity($event)"
                                    bindLabel="zipCode"
                                    bindValue="zipCode"
                                    addTagText="Dodaj poštno št."
                                    placeholder="Poštna številka"
                                    formControlName="postNumber"
                                    i18n-placeholder="@@post_number"
                                ></ng-select>
                                <div *ngIf="inputForm.controls['postNumber'].errors && formSubmitted" class="m--font-danger">
                                    <div [hidden]="!inputForm.controls['postNumber'].errors.required" i18n="@@new.payer.error.postNumber">
                                        Poštna številka je obvezno polje.
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-md-6">
                                <ng-select
                                    [items]="zipCodes"
                                    [addTag]="true"
                                    [clearable]="false"
                                    [virtualScroll]="true"
                                    (change)="fillPost($event)"
                                    bindLabel="city"
                                    bindValue="city"
                                    addTagText="Dodaj pošto"
                                    placeholder="Pošta"
                                    formControlName="postName"
                                    i18n-placeholder="@@post_city"
                                ></ng-select>
                                <div *ngIf="inputForm.controls['postName'].errors && formSubmitted" class="m--font-danger">
                                    <div [hidden]="!inputForm.controls['postName'].errors.required" i18n="@@new.payer.error.postName">
                                        Pošta je obvezno polje.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>
                </div>

                <section>
                    <div class="m-list-search__result-item">
                        <span class="m-list-search__result-item-icon">
                            <span ngbTooltip="Poštni predal" class="la la-inbox m--font-inverse-light" i18n-ngbTooltip></span>
                        </span>
                        <span class="m-list-search__result-item-text">
                            <input
                                formControlName="postBox"
                                type="text"
                                placeholder="Poštni predal"
                                class="form-control form-control-sm m-input"
                                i18n-placeholder
                            />
                        </span>
                    </div>
                    <div *ngIf="inputForm.controls['postBox'].errors && formSubmitted" class="m--font-danger ml-4">
                        <div [hidden]="!inputForm.controls['postBox']?.errors?.pattern" class="ml-3" i18n="@@new.payer.error.postBox">
                            Dovoljen vnos samo števil.
                        </div>
                    </div>
                </section>
                <div class="m-list-search__result-item">
                    <span class="m-list-search__result-item-icon">
                        <span ngbTooltip="Davčna številka" class="la la-euro m--font-inverse-light" i18n-ngbTooltip></span>
                    </span>
                    <span class="m-list-search__result-item-text">
                        <input
                            formControlName="taxId"
                            type="text"
                            placeholder="Davčna številka"
                            class="form-control form-control-sm m-input"
                            i18n-placeholder
                        />
                        <div *ngIf="inputForm.controls['taxId'].errors && formSubmitted" class="m--font-danger ml-4">
                            <div [hidden]="!inputForm.controls['taxId']?.errors?.minLength" class="ml-3">
                                Davčna številka mora biti dolga vsaj 8 znakov.
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</form>
